module.exports = __webpack_public_path__ + "static/media/hair accessories-gray.fdf5015f.svg";